// eslint-disable-next-line import/extensions
import YkcDialog from './src/main.js';

export default YkcDialog;
